import { Link } from "office-ui-fabric-react"

const WorkWeekSettingsTooltip = () => {
    return <div>Define the number of working hours per day at the organizational level.Global Work Week settings are used to calculate resource capacity (unless personal work week settings are applied to a resource) and are considered in PPM Express tasks.Please note that managing this setting requires the 'Manage Resources' permission.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/621569-calendar" target="_blank">article</Link> for more details.</div>;
}

export default WorkWeekSettingsTooltip;